module.exports = __webpack_public_path__ + "img/truc3.f0fd2004.png";